import { render, staticRenderFns } from "./UOMList.vue?vue&type=template&id=62d4183f&scoped=true"
import script from "./UOMList.vue?vue&type=script&lang=js"
export * from "./UOMList.vue?vue&type=script&lang=js"
import style0 from "./UOMList.vue?vue&type=style&index=0&id=62d4183f&prod&lang=scss&scoped=true"
import style1 from "./UOMList.vue?vue&type=style&index=1&id=62d4183f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4183f",
  null
  
)

export default component.exports